import { render } from "./BuildingTab.vue?vue&type=template&id=14e8bac8"
import script from "./BuildingTab.vue?vue&type=script&lang=js"
export * from "./BuildingTab.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__